import mixpanel from 'mixpanel-browser';
export const getMixpanel = (user, message, property) => {
    mixpanel.init('0419a19ed1ac33c08c4378586109a61e');
    // create or update a user in Mixpanel Engage
    mixpanel.identify(user);
    mixpanel.track(message, Object.assign({ distinct_id: user }, property));
};
